import React from 'react';
import { Pie, PieChart } from 'recharts';
import {
  CHART_COLORS,
  CHART_HEIGHT,
  CHART_WIDTH,
  INNER_PIE_CHART_INNER_RADIUS,
  INNER_PIE_CHART_OUTER_RADIUS,
  OUTER_PIE_CHART_INNER_RADIUS,
  PIE_CHART_OUTER_RADIUS,
} from './Statistics';

function EmptyPieChart() {
  const emptyData = [{ name: '', value: 1 }];

  return (
    <PieChart width={CHART_WIDTH / 2} height={CHART_HEIGHT}>
      <Pie
        data={emptyData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={INNER_PIE_CHART_OUTER_RADIUS}
        innerRadius={INNER_PIE_CHART_INNER_RADIUS}
        fill={CHART_COLORS.disable}
        isAnimationActive={false}
      ></Pie>
      <Pie
        data={emptyData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={PIE_CHART_OUTER_RADIUS}
        innerRadius={OUTER_PIE_CHART_INNER_RADIUS}
        fill={CHART_COLORS.disable}
        isAnimationActive={false}
      ></Pie>
    </PieChart>
  );
}

export default EmptyPieChart;
